import React, { ReactElement, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Loading from '@ch/common/components/loading/loading';
import { AppContext } from './app-context';
import Main from './main';
import { loadFile } from './quiz/helpers';

const App = (): ReactElement => {
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [dropdownData, setDropdownData] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <AppContext.Provider
      value={{
        loading,
        setLoading,
        data,
        setData,
        dropdownData,
        setDropdownData,
        loadFile,
      }}
    >
      <>
        <Main />
        {loading && <Loading $fullScreen />}
      </>
    </AppContext.Provider>
  );
};

export default App;
